// extracted by mini-css-extract-plugin
module.exports = {"totalColumn":"TotalRow_totalColumn__qkdGN","label":"TotalRow_label__2PDSJ"};